import api from 'api/apiClient';
import { ensureFileId } from 'modules/shared/service';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

const normalizeNewsPayload = async (article) => ({
  name: article.title,
  content: article.content,
  headline: article.title,
  reference_link: article.referenceLink,
  image: await ensureFileId(article.photo),
});

export const postNewsArticle = async (article) => {
  if (!article) return;
  const payload = await normalizeNewsPayload(article);
  return await unwrap(await api.post('/api/hr/add-news', payload));
};

export const updateNewsArticle = async (id, article) => {
  if (!id || !article) return;
  const payload = await normalizeNewsPayload(article);
  return await unwrap(await api.put(`/api/hr/news/${id}`, { id, ...payload }));
};

export const deleteNewsArticle = async (id) => {
  if (!id) return;
  return await unwrap(await api.delete(`/api/hr/news/${id}`));
};

export const getAllNewsArticles = async () => {
  const { data: raw } = await unwrap(await api.get('/api/hr/news'));

  return raw.map((article) => ({
    id: article.id,
    title: article.name,
    headline: article.headline,
    content: article.content,
    referenceLink: article.reference_link,
    photo: article.image,
  }));
};
